<template>
  <div class="contact-us_mobile">
    <div class="contact-us_mobile-wraper">
      <h2>联系我们</h2>
      <p style="margin-bottom: 16px">打造智能化未来，引领科技创新</p>
      <ul>
        <li v-for="(branch, index) in branches" :key="index">
          <h3>{{ branch.name }}</h3>
          <div class="line"></div>
          <p style="margin-top: 12px; margin-bottom: 12px">
            地址：{{ branch.address }}
          </p>
          <p>
            电话：<span style="opacity: 1; color: #1E242A ;font-weight: bold;">{{
              branch.phone
            }}</span>
          </p>
        </li>
      </ul>
      <!-- <h2 style="margin-top: 30PX;">业务咨询</h2>
            <p>定制产品解决方案，即享智能化升级</p>
            <el-form :model="form" :rules="rules" ref="form" label-width="0PX" class="contact-form" style="width: 50%;">
                <el-form-item class="half-width" prop="name">
                    <el-input v-model="form.name" placeholder="请输入公司名称"></el-input>
                </el-form-item>
                <el-form-item class="half-width" prop="email">
                    <el-input v-model="form.email" placeholder="请输入公司邮箱"></el-input>
                </el-form-item>
                <el-form-item class="half-width" prop="appointmentTime">
                    <el-date-picker v-model="form.appointmentTime" placeholder="请输入预约时间"
                        style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item class="half-width" prop="address">
                    <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item class="half-width" prop="contacts">
                    <el-input v-model="form.contacts" placeholder="请输入联系人"></el-input>
                </el-form-item>
                <el-form-item class="half-width" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
                <el-form-item class="full-width" prop="demand">
                    <el-input v-model="form.demand" type="textarea" placeholder="请输入您的需求"></el-input>
                </el-form-item>
                <el-form-item prop="agreement">
                    <el-checkbox v-model="form.agreement">
                        勾选表示：您同意华软及其授权的合作伙伴通过填写的联系方式联系您，且数据仅用于与您沟通。
                    </el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :disabled="!form.agreement" @click="submitForm" class="submit-button">
                        立即咨询
                    </el-button>
                </el-form-item>
            </el-form> -->
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="500PX"
      class="consult-dialog"
    >
      <div class="dialog-content">
        <div class="icon"></div>
        <p>信息已提交，请耐心等待...</p>
        <el-button type="primary" @click="dialogVisible = false"
          >知道了</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ConsultDialog from "./ConsultDialog.vue";
import { consultationLogAdd } from "@/api/log.js";
export default {
  name: "ContactUs",
  components: {
    ConsultDialog,
  },
  data() {
    return {
      branches: [
        {
          name: "总部",
          address: "中国（上海）自由贸易试验区川桥路701弄3号103室",
          phone: "400-608-3777",
        },
        {
          name: "营销中心",
          address: "北京市丰台区南四环西路186号四区7号楼9M",
          phone: "024-88837777-6026",
        },
        {
          name: "垂直行业运营总部",
          address: "北京市朝阳区建国路89号华贸商务楼15号楼803室",
          phone: "010-68028728",
        },
        {
          name: "生产基地",
          address: "辽宁省沈阳市苏家屯区桂竹香街智能制造装备产业园68-A3/G5/J2栋  ",
          phone: "024-88837777",
        },
      ],
      form: {
        name: "",
        email: "",
        appointmentTime: "",
        address: "",
        contacts: "",
        phone: "",
        demand: "",
        agreement: false,
      },
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        email: [
          { required: true, message: "请输入公司邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
        ],
        appointmentTime: [
          { required: true, message: "请输入预约时间", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        demand: [
          { required: true, message: "请输入您的需求", trigger: "blur" },
        ],
        agreement: [
          {
            required: true,
            type: "boolean",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请勾选同意协议"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      if (!this.form.agreement) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.openDialog();
        } else {
          console.error("表单验证失败");
        }
      });
    },
    openDialog() {
      // 格式化预约时间为YYYY-MM-DD
      let formData = { ...this.form };
      if (formData.appointmentTime) {
        const date = new Date(formData.appointmentTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        formData.appointmentTime = `${year}-${month}-${day}`;
      }

      this.dialogVisible = true; // 确保点击按钮时设置为 true

      const { result } = consultationLogAdd(formData);
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-us_mobile {
  width: 100%;
  // height: 1000PX;
  text-align: center;
  // padding: 10px 0px;
  // padding-top: 70px;
  background-image: url("../../assets/home/lianXiUsMobile.png");
  background-size: 100% 100%;
  background-position: center;
  padding: 40px 16px;

  .contact-us_mobile-wraper {
    // width: 1200px;
    margin: 0 auto;
  }

  h2 {
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    color: #1e242a;
    margin-bottom: 10px;
    text-align: left;
  }

  p {
    font-family: PingFang SC;
    font-size: 10px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1e242a99;
    margin-bottom: 0px;
    text-align: left;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    gap: 20px;

    li {
      width: 100%;
      background: linear-gradient(180deg, #F4F6F9 0%, rgba(255, 255, 255, 0.01) 100%);
      border: 1px solid #ffffff;
      text-align: center;
      padding: 12px 12px 18px;
      border-radius: 4px;
      margin-bottom: 12px;

      h3 {
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: bold;
        color: #1e242a;
        margin-bottom: 12px;
        text-align: left;
      }

      .line {
        height: 1px;
        border-radius: 2px;
        background: rgba(15, 107, 246, 0.08);
        margin: 0 auto;
        width: 100%;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .contact-form {
    margin-top: 16px;
    text-align: left;

    .el-form-item {
      margin-bottom: 10px;
    }

    .el-checkbox {
      font-size: 14px;
      color: #1e242a;
      opacity: 0.6;
    }

    .el-button {
      width: 100%;
    }

    .submit-button {
      width: 160px;
      height: 40px;
      background-color: #0f6bf6;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .half-width {
      width: 50%;
      display: inline-block;
      padding-right: 20px;
      box-sizing: border-box;

      &:nth-child(2),
      &:nth-child(4),
      &:nth-child(6) {
        padding-right: 0;
      }
    }

    .full-width {
      width: 100%;
    }
  }
}

.consult-dialog {
  .dialog-content {
    text-align: center;
    width: 100%;
    height: 400px;
    text-align: center;
    padding: 32px;
    background-image: url("../../assets/home/clockBg.png");
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .icon {
      font-size: 50px;
      color: #0f6bf6;
      margin-bottom: 60px;
      background-image: url("../../assets/home/clock.png"); // 确保图片路径正确
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      width: 140px;
      /* 修改宽度 */
      height: 140px;
      /* 修改高度 */
    }

    p {
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: normal;
      color: #1e242a;
      opacity: 1;
      margin-bottom: 30px;
    }

    .el-button {
      width: 160px;
      height: 40px;
      border-radius: 4px;
      background: #0f6bf6;
      margin: 0 auto;
    }
  }
}

::v-deep .el-dialog__header {
  // padding: 0 !important;
}

::v-deep .el-dialog__body {
  padding: 0 !important;
}

::v-deep .el-dialog__footer {
  padding: 10px !important;
}

::v-deep .el-input__inner {
  border: none;
}
</style>
